import { observer } from "mobx-react";
import ErrorBlock from "./ErrorBlock";
import { IBlockComponentProps } from "./_Block";
import { useStores } from "../../../stores/useStores";
import { UserAvatar } from "../../utilities/UserAvatar";

interface IPersonBlockProps extends IBlockComponentProps {
  blockObj: IPersonBlock;
}

const PersonBlock = observer((props: IPersonBlockProps) => {
  try {
    const { modalStore } = useStores();
    const { blockObj } = props;

    const modalObj: IPersonModalObj = {
      id: blockObj.blockModel.id,
      type: "schoolBlocksPerson",
      blockObj,
    };

    return (
      <button
        className="sb-block-container"
        onClick={() => modalStore.addModal(modalObj)}
      >
        <table role="presentation" className="sb-teacher-card">
          <tbody>
            <tr>
              <td className="sb-teacher-card-image-cell">
                <UserAvatar
                  avatarUrl={blockObj.blockModel.avatarUrl}
                  fname={blockObj.blockModel.fname}
                  lname={blockObj.blockModel.lname}
                  size="7"
                />
              </td>
              <td className="sb-teacher-card-info-cell sb-organization-color-block-font">
                <div className="sb-h1">
                  <span className="sb-teacher-card-name notranslate">
                    {blockObj.blockModel.fname}
                  </span>
                  <span className="sb-teacher-card-name notranslate">
                    {" "}
                    {blockObj.blockModel.lname}
                  </span>
                  <div className="sb-teacher-card-title">
                    {blockObj.blockModel.title}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </button>
    );
  } catch (_e: unknown) {
    const e: Error = _e as Error;
    return <ErrorBlock blockObj={{ errorMessage: e }} />;
  }
});

export default PersonBlock;
